import React ,{useContext} from 'react'
import { useSelector } from 'react-redux'
import { Accordion, AccordionItem } from '../../../commonComponents/accordion'
import ActorDetailHeader from './actorDetailHeader'
import GuaranteeDetails from './guaranteeDetails'
import ErrorMessagesWindow from '@commonComponents/errorValidationWindow'
import ActorDetailForm from '../../../commonComponents/formComponents/actorDetailForm'
import { Broker, Buyer, Seller, Consignee, Consignor } from './Actors'
import { ActorContext } from './Actors/actorProvider'
import ErrorWindowPartiesTab from './ErrorWindowPartiesTab'

function PartiesForm(props) {
  const { isFormDisabled, translate } = props
  const actorDetails = useContext(ActorContext)
  const actorDetailForm = (params) => {
    return <ErrorWindowPartiesTab dataSource={params.dataSource} actorType={params.actorType} translate={translate}>
 
      {(errorInfo) => <ActorDetailForm 
              disabled={isFormDisabled}
              {...params} 
              {...actorDetails}
              repKey = 'formOfRepresentation'
              eoriKey='externalIdentification'
              address2 = 'address2'
              countryKey='countryCode'
              errorInfo={errorInfo}
            ></ActorDetailForm>}</ErrorWindowPartiesTab>
  }

  const ErrorWarningsList = useSelector((state) => state.ServerErrorReducer?.partiesTab) || []

  return (
    <div className='formContentareaC88 headerDetails'>
      {ErrorWarningsList?.length > 0 && !props.disabled && (
        <ErrorMessagesWindow errors={ErrorWarningsList} />
      )}
      <Accordion translate={translate}>
        <AccordionItem
          actorType='consignor'
          idText={`showConsignor`}
          id='1'
          boxNumber='2'
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title={translate('CONSIGNOR', { ns: ['default', 'parties'] })}
              actorType='consignor'
              {...props}
            ></ActorDetailHeader>
          )}
        >
         
          <Consignor renderForm={actorDetailForm} />
        </AccordionItem>
        <AccordionItem
          actorType='consignee'
          idText={`showConsignee`}
          id='2'
          boxNumber='8'
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title={translate('CONSIGNEE', { ns: ['default', 'parties'] })}
              actorType='consignee'
              {...props}
            ></ActorDetailHeader>
          )}
        >
        
          <Consignee renderForm={actorDetailForm} />
        </AccordionItem>
        <AccordionItem
          actorType='broker'
          idText={`showBroker`}
          id='3'
          boxNumber='14'
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title={translate('DECLARANT', { ns: ['default', 'parties'] })}
              actorType='broker'
              {...props}
            ></ActorDetailHeader>
          )}
        >
         
          <Broker renderForm={actorDetailForm} />
        </AccordionItem>
        <AccordionItem
          actorType='buyer'
          idText={`showBuyer`}
          id='4'
          boxNumber=''
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title={translate('BUYER', { ns: ['default', 'parties'] })}
              actorType='buyer'
              {...props}
            ></ActorDetailHeader>
          )}
        >
          
          <Buyer renderForm={actorDetailForm} />
        </AccordionItem>
        <AccordionItem
          actorType='seller'
          idText={`showSeller`}
          id='5'
          boxNumber=''
          translate={translate}
          title={(props) => (
            <ActorDetailHeader
              title={translate('SELLER', { ns: ['default', 'parties'] })}
              actorType='seller'
              {...props}
            ></ActorDetailHeader>
          )}
        >
         
          <Seller renderForm={actorDetailForm} />
        </AccordionItem>
      </Accordion>

      <GuaranteeDetails
        isFormDisabled={isFormDisabled}
        translate={translate}
      />
    </div>
  )
}

export default  React.memo(PartiesForm)